import Logo from 'components/ui/Logo';
import MinifiedLogo from 'components/ui/MinifiedLogo';
import { AppContext, AppContextType } from 'context/AppContext';
import * as React from 'react';

export type SystemLogoProps = {
    drawerOpen: boolean;
};

const SystemLogo = ({ drawerOpen }: SystemLogoProps) => {
    const { ownUser } = React.useContext(AppContext) as AppContextType;

    return (
        <>
            {ownUser && (
                <>
                    {!ownUser?.company?.partner ? (
                        <>{drawerOpen ? <Logo /> : <MinifiedLogo />}</>
                    ) : (
                        <>
                            {drawerOpen ? (
                                <img
                                    src={ownUser?.company?.partner.configuredAvatar}
                                    alt={ownUser?.company?.partner.name}
                                    style={{
                                        minHeight: '40px',
                                        maxHeight: '60px'
                                    }}
                                />
                            ) : (
                                <img
                                    src={ownUser?.company?.partner.configuredShortAvatar}
                                    alt={ownUser?.company?.partner.name}
                                    style={{
                                        minHeight: '40px',
                                        maxHeight: '60px'
                                    }}
                                />
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default SystemLogo;
